// The SPA's copies of the API's enums and patterns. The SPA does not depend on @ascera/shared,
// so these are hand-written; api-enums.test.ts checks every one against openapi.json.

/** The label filters GET /admin/feedback accepts. */
export const FEEDBACK_LABELS = {
  kind: ['bug', 'feature_request', 'praise', 'complaint', 'question', 'other'],
  surface: [
    'jules_chat',
    'practices',
    'check_in',
    'reflect',
    'account',
    'billing',
    'onboarding',
    'other',
  ],
  sentiment: ['negative', 'neutral', 'positive'],
} as const;

/** GET /admin/feedback's subscription_status and GET /admin/users's status. */
export const SUBSCRIPTION_STATUSES = [
  'none',
  'trial',
  'active',
  'grace_period',
  'cancelled',
  'lapsed',
  'comp',
] as const;

/** The keys a feedback row's client_meta may carry, in the API's order. */
export const CLIENT_META_KEYS = [
  'update_id',
  'runtime_version',
  'git_sha',
  'os_version',
  'locale',
  'device_model',
] as const;

export type ClientMetaKey = (typeof CLIENT_META_KEYS)[number];

/** GET /admin/feedback's from and to. */
export const UTC_DAY_PATTERN = '^(?!0000)\\d{4}-\\d{2}-\\d{2}$';
/** GET /admin/feedback's user_id. */
export const UUID_PATTERN =
  '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$';
